module.exports = __webpack_public_path__ + "img/dep_household@2x.ccc2e590.png";